import { Helmet } from 'react-helmet'
import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../components/Layout'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'

import CTA from '../components/CTA'
import Header from '../components/Header'
import {
  SplitContent,
  SplitFigure,
  Container,
  SplitSection,
  ReadMore,
  Text
} from '../components/styles'
import Arrow from '../components/Arrow'
import styled from 'styled-components'
import Hero from '../components/Hero'
import { AboutContact } from '.'
import FAQs from '../components/FAQs'
import Testimonials from '../components/Testimonials'
import { allTestimonials } from './testimonials'

const Value = styled(Container).attrs({
  bg: '#fff',
  medium: true,
  shadow: true
})`
  margin-bottom: 1.5rem;
  padding: 3rem;

  > div > div:first-child {
    padding-right: 3rem;
  }
`

const StyledFlex = styled(Flex)`
  @media (max-width: 639px) {
    flex-direction: column;
    > div {
      margin-bottom: 2rem;
    }
  }
`

const StyledHero = styled(Hero)`
  display: flex;
  align-items: center;
  width: 100vw;
  margin: 0;
`
const Info = styled.div`
  z-index: 10;
  background: #fff;
  padding: 1rem 3rem;
  border-radius: 8px;
  margin-top: 30vh;
  text-align: center;
  max-width: 600px;
  h3 {
    color: ${props => props.theme.colors.dark};
    text-shadow: none;
  }
`

/* prettier-ignore */
interface IProps {
  data: {
    coast: {
      childImageSharp: {
        fluid: object
      }
    };
    ecology: {
      childImageSharp: {
        fluid: object
      }
    };
    top: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout header="light">
    <Helmet>
      <title>About Us - GFit Australian Sportswear</title>
      <meta
        name="description"
        content="Meet Gavin Fitness, Australian athlete, coach and leading sportswear manufacturer. The GFit team are dedicated to furthering the development of high-quality local sporting apparel."
      />
    </Helmet>
    <StyledHero height="60vh" noForm={true} bgImage={data.top.childImageSharp}>
      {/* <Info>
        <h3>
          <Box mb={3}>
            <h5>GFit Sportswear</h5>
          </Box>
          Discover the power of high quality, custom sportswear
        </h3>
      </Info> */}
    </StyledHero>

    <Container padY={true} medium={true}>
      <SplitSection>
        <SplitFigure>
          {/* <Img
            fluid={data.meetSellars.childImageSharp.fluid}
            alt="GFit Gavin"
          /> */}
          <Img
            // style={{ marginTop: 50 }}
            fluid={data.meetGavin.childImageSharp.fluid}
            alt="GFit Gavin"
          />
        </SplitFigure>
        <SplitContent>
          <h2>Meet Gavin Fitness</h2>
          <h4>About GFit</h4>
          <p>
            GFit is a family owned Queensland based sportswear company. Our
            director, Gavin Fitness has been involved in sport at all levels,
            growing up in country Queensland he developed a passion for all
            sports, his sporting journey has been one that has seen him travel
            the world as a professional cricketer, coach professionally locally,
            nationally and internationally, work as a committee member of both
            junior and senior sporting clubs and best of all, be a parent on the
            side line encouraging kids to have fun, it would be fair to say he
            has a wealth of knowledge and understanding of sporting clubs across
            all levels.
          </p>
          <h4>About Gavin</h4>
          <p>
            After retiring from his professional playing career, he was lured
            into the sportswear industry in roles representing some of the
            largest brands in the industry, he continued to grow his knowledge
            and build a network within this industry for several years before
            taking on roles on the coaching staff with the Qld Bulls and
            Brisbane Heat cricket teams.{' '}
          </p>
          <p>
            After stepping away from the busy schedule and all the travel
            involved in coaching, he utilized his sportswear industry network
            both locally and overseas and soon after the GFIT label became a
            reality.{' '}
          </p>
          <p>
            Gavin is very passionate about Queensland sport, he is lucky enough
            to tour regional areas regularly with his beloved Queensland Bulls
            Masters Cricket team to help communities raise funds for junior
            sport and to assist with creating pathways for kids from the bush to
            chase their dreams.
          </p>
          <p>
            His passion for sport, seeing kids enjoy being a part of a team and
            in some cases watching them chase their dreams is something that
            will never fade.
          </p>

          <p>
            Yours in Sport
            <br />
            Gavin Fitness.
          </p>

          <ReadMore to="/contact">
            Contact Gavin Today
            <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>
    </Container>

    <Flex id="team" justifyContent="center" mb={4}>
      <h1>Our Team</h1>
    </Flex>
    <Container
      style={{ borderRadius: 4 }}
      bg="#eaf8ff"
      padY={true}
      medium={true}
    >
      <SplitSection style={{ marginLeft: 0 }}>
        <SplitFigure>
          <Img fluid={data.sewing.childImageSharp.fluid} alt="GFit Gavin" />
        </SplitFigure>
        <SplitContent>
          <h5>Meet our Team</h5>
          <p>
            The entire GFIT team are very much people persons, hardworking,
            passionate and fun people that take the time to care about each
            individual client. The relationships built between the GFIT staff
            and our clients is just one of the many reasons people keep on
            coming back.
          </p>

          <ReadMore to="/contact">
            Contact the team
            <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>
      <Flex justifyContent="center" mt={5}>
        <h3>
          Contact our crew today, they set a standard second to none in the
          industry.
        </h3>
      </Flex>
    </Container>

    <Flex mt={6} />

    <Testimonials testimonials={allTestimonials} />

    <AboutContact data={data} />

    <CTA
      title="Having a growth issue?"
      subtitle="We’re here to help you."
      button="Contact Us"
    />
  </Layout>
)

export const query = graphql`
  query AboutPageQuery {
    top: file(relativePath: { eq: "sports-break.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    meetSellars: file(relativePath: { eq: "gavin.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    meetGavin: file(relativePath: { eq: "gavin2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    drSellars: file(relativePath: { eq: "about-gfit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    sewing: file(relativePath: { eq: "sewing.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000, quality: 95) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
